var $=jQuery;
$(document).ready(function(){
  $('.icon-with-text-item').each(function () {
    const $item = $(this);
    const link = $item.find('.icon-text a').attr('href'); 

    if (link) {
      const $img = $item.find('.icon img');

      if (!$img.parent().is('a')) {
        $img.wrap(`<a href="${link}"></a>`);
      } else {
        $img.parent('a').attr('href', link); 
      }
    }
  });
  
   $('.product__tax a:contains("Versand")').on('click', function(e) {
    e.preventDefault();
    $('#tax-popup-wrapper').removeClass('tax-popup-hidden');
    });

  $('#close-tax-popup, #tax-popup-overlay').on('click', function() {
    $('#tax-popup-wrapper').addClass('tax-popup-hidden');
  });

  $(document).on('click', function(e) {
    if (!$(e.target).closest('#tax-popup').length && !$(e.target).is('.product__tax a:contains("Versand")')) {
      $('#tax-popup-wrapper').addClass('tax-popup-hidden');
    }
  });
  
   $('#show-more-btn').click(function () {
       $('.premium-table .hidden-row').css('display', 'table-row'); 
       $('.premium-table').addClass('expanded'); 
      $(this).hide()
    });
  
   $('[name="id"]').on('change', function () {
      const selectedId = $(this).val();
      const url = new URL(window.location.href);
      url.searchParams.set("variant", selectedId);
      window.location.href = url.toString();
    });
  
    $('.category-text').click(function (e) { 
      e.preventDefault();
      $(this).toggleClass('active');
  });

  
   // $(".tag-item").click(function() {
   //        $(".blog-articles.blog-posts").html('');
   //        var selectedTag = $(this).data("tag");
   //       var requestUrl = "/blogs/wissensdatenbank/tagged/" + selectedTag;
   //            $(".tag-item").removeClass('active');
   //            $(this).addClass('active');
            
   //        $.ajax({
   //          url: requestUrl,
    
   //          type: 'GET',
   //          data: { tag: selectedTag }, 
   //          beforeSend: function() {
   //            // $('#blog-posts-wrapper').html('<p>Loading...</p>');
   //          },
   //          success: function(response) {
   //            $(".pagination").hide();
   //            var newPosts = $(response).find(".blog-posts1").html();
   //            $(".blog-articles-tag  .blog-posts").html(newPosts);
   //                 $('.myBtn').click(function (e) { 
   //                    e.preventDefault();
   //                    const $modal = $(this).parent().find('.modal-box');
   //                    $modal.show();
   //                });
   //              $('.close').click(function (e) {
   //                  $('.youtube-video').each(function () {
   //                    this.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
   //                  });
   //                  $('.modal-box').hide();
                    
   //              });
              
   //            // Set active class
   //          },
   //          error: function(xhr, status, error) {
              
   //          }
   //        });
   //      });
  
  $('.header-top-mb span.svg-wrapper.icon-search-svg').click(function (e) { 
      e.preventDefault();
      $('#menu-drawer').toggleClass('active-search');
  });
  $('.footer-block.has-dropdown h2.footer-block__heading').click(function (e) { 
      e.preventDefault();
      $(this).toggleClass('active');
  });
   $('.dropbtn').click(function (e) { 
      e.preventDefault();
      $(this).toggleClass('active');
  });
  $('.load-more').click(function (e) { 
      e.preventDefault();
      $(this).hide();
      $(this).closest('.multicolumn-card__info').addClass('active');
  });
  if($(window).width() <= 949){
      var trust  = new Swiper('.trust-icon .icon-with-text-wrapper', {
        slidesPerView: 1,
        spaceBetween:0,
        loop: true,
        // autoplay: {
        //   delay: 10000,
        //   disableOnInteraction: false,
        // },
        navigation: {
          nextEl: '.trust-icon .swiper-button-next',
          prevEl: '.trust-icon .swiper-button-prev',
        },
      });
  }
   $('.video-trigger').on('click', function () {
    var ytbUrl = $(this).data('ytb');
    var videoUrl = $(this).data('video');
    var finalUrl = ytbUrl ? ytbUrl : videoUrl;
  
    if (finalUrl) {
      if (ytbUrl) {
        $('#popup-video').replaceWith(
            '<iframe id="popup-video" width="100%" height="100%" src="' + finalUrl + '?autoplay=1&rel=0" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>'
        );
      } else {
        $('#popup-video').attr('src', finalUrl);
      }
  
      $('#video-popup').removeClass('hidden');
    }
  });
  
  $('.video-popup__close, .video-popup__overlay').on('click', function () {
    $('#video-popup').addClass('hidden');
  
    var $video = $('#popup-video');
  
    if ($video.is('iframe')) {
      $video.replaceWith('<video id="popup-video" width="100%" height="100%" controls></video>');
    } else {
      $video.get(0).pause();
      $video.attr('src', '');
    }
  });
  // $('#mit_unterbau').on('change', function() {
  //     var redirectUrl = $(this).data('url');
  //     if (redirectUrl) {
  //       window.location.href = redirectUrl;
  //     }
  // });
  
  $('.download-section h6').click(function() {
      $('.download-section').toggleClass('download-section-show');
  });
  
   // var $faqItems = $(".collection-info .faq-item");
   //  var $button = $(".collection-info .button--primary");

   //  $faqItems.hide().slice(0, 4).show();

   //      if ($faqItems.length <= 4) {
   //      $button.hide(); 
   //  } 
   //  $button.on("click", function () {
   //      $faqItems.slideDown();
   //      $(this).hide();
   //  });
      
  $('.modal-box').click(function() {
    $('.modal-box').hide();
    $('.youtube-video').each(function () {
        this.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
      });
  });
  $('.modal-content').click(function(event){
    event.stopPropagation();
  });
   $('.myBtn').click(function (e) { 
    e.preventDefault();
    const $modal = $(this).parent().find('.modal-box');
    $modal.show();
  });
  // const $modal = $(this).parent().find('.modal-box');
  // $modal.show();
  //   setTimeout(function () {
  //     $modal.hide();
  //   }, 4000);
  // });
  // $('.myBtn_1').trigger('click');
 
  $('.close').click(function (e) {
      $('.youtube-video').each(function () {
        this.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
      });
      $('.modal-box').hide();
      
  });

});


/****** theme custom menu appears on hover Start ******/
     // Add this code make menu appears on hover
          function bindMouseOverToMegaMenu (item) {
            item.addEventListener("mouseover", () => {
                item.setAttribute("open", true);
                item.querySelector(".mega-menu__content, .header__submenu").addEventListener("mouseover", () => {
                  item.setAttribute("open", true);
                });
                item.querySelector(".mega-menu__content, .header__submenu").addEventListener("mouseleave", () => {
                  item.removeAttribute("open");
                });
              item.addEventListener("mouseleave", () => {
                item.removeAttribute("open");
              });
            });
          }
     let main_header_iner_items = document.querySelector(".header__inline-menu");
    if(main_header_iner_items){
    let items = main_header_iner_items.querySelectorAll("details.mega_menu_hover, details.drop-down-hover");
    items.forEach(bindMouseOverToMegaMenu);
    }
/****** theme custom menu appears on hover End ******/

// blog sorting
  $('.filter-blog-icon,.dropdown-title').click(function (e) { 
        e.preventDefault();
        $(this).toggleClass('active');
  });
  $("#sorting-dropdown").change(function() {
      var selectedOption = $(this).val();
      sortBlogPosts(selectedOption);
  });
  $('.blog-search').on('input', function(){
    var get_input = $(this).val().toLowerCase(); 
    $('.blog-articles__article').each(function(){
        var articleHeading = $(this).find('.card__heading a').text().toLowerCase();
        if(articleHeading.includes(get_input)){
            $(this).show();
        }
        else{
            $(this).hide();
        }
    });
  });
  function sortBlogPosts(option) {
    var postsContainer = $(".blog-articles");
    var posts = postsContainer.children(".cust_sort_blog");
  
    switch (option) {
      case "title-ascending":
        posts.sort(function(a, b) {
          return $(a).find(".blog-post-title").text().localeCompare($(b).find(".blog-post-title").text());
        });
        break;
      case "title-descending":
        posts.sort(function(a, b) {
          return $(b).find(".blog-post-title").text().localeCompare($(a).find(".blog-post-title").text());
        });
        break;
      case "created-ascending":
        posts.sort(function(a, b) {
          var dateA = new Date($(a).find(".blog-post-date").text());
          var dateB = new Date($(b).find(".blog-post-date").text());
          return dateA - dateB;
        });
        break;
      case "created-descending":
        posts.sort(function(a, b) {
          var dateA = new Date($(a).find(".blog-post-date").text());
          var dateB = new Date($(b).find(".blog-post-date").text());
          return dateB - dateA;
        });
        break;
      default:
        // No sorting, maintain original order
        break;
    }
  
    postsContainer.empty().append(posts);
  }